/**
 * SuperEmployeeTable Component
 * Collapsible superannuation per-employee breakdown within Compliance tab
 */

import { SectionCard } from './SectionCard';
import { formatCurrency } from '@/utils/formatters';
import type { ComplianceSnapshotResponse } from '@/api/complianceApi';

interface SuperEmployeeTableProps {
  employees: ComplianceSnapshotResponse['data']['superSummary']['employees'];
}

export function SuperEmployeeTable({ employees }: SuperEmployeeTableProps) {
  return (
    <SectionCard title="Super by Employee">
      {employees.length > 0 ? (
        <div className="compliance-dashboard__table">
          <div className="compliance-dashboard__table-header">
            <span>Employee</span>
            <span>OTE</span>
            <span>Super</span>
          </div>
          {employees.map((emp) => (
            <div key={emp.employeeId} className="compliance-dashboard__table-row">
              <span className="compliance-dashboard__emp-name">{emp.employeeName}</span>
              <span className="compliance-dashboard__emp-value">
                {formatCurrency(emp.ordinaryTimeEarnings)}
              </span>
              <span className="compliance-dashboard__emp-value">
                {formatCurrency(emp.superAmount)}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="compliance-dashboard__empty">No employee super data available</p>
      )}
    </SectionCard>
  );
}
